import { createContext as t, useReducer as e, useContext as o, useRef as r, useEffect as n, useCallback as u } from "react";
import a from "react-dom";

function i() {}

var s = t(null),
    c = s.Provider,
    l = function l(t) {
  return t;
};

function f(t) {
  return void 0 === t && (t = s), function (u, a, s) {
    void 0 === a && (a = l), void 0 === s && (s = []);
    var c = e(function (t) {
      return t + 1;
    }, 0)[1],
        f = o(t);
    if (!f) throw new Error("[reatom] The provider is not defined");
    var m = r({
      store: f,
      atom: void 0,
      selector: a,
      deps: s,
      atomValue: void 0,
      selectorValue: void 0,
      unsubscribe: i,
      mountStatus: "init"
    }).current;
    if (m.selector = a, f !== m.store || u !== m.atom) m.store = f, m.atom = u, m.deps = s, m.unsubscribe(), m.unsubscribe = f.subscribe(m.atom, function (t) {
      if (!Object.is(m.atomValue, t)) {
        m.atomValue = t;
        var e = m.selector(t);
        Object.is(e, m.selectorValue) || (m.selectorValue = e, "init" === m.mountStatus ? m.mountStatus = "outOfDate" : c());
      }
    }), m.atomValue = m.store.getState(u), m.selectorValue = m.selector(m.atomValue);else {
      var d = m.store.getState(m.atom);
      Object.is(d, m.atomValue) && s.length === m.deps.length && !s.some(function (t, e) {
        return !Object.is(t, m.deps[e]);
      }) || (m.deps = s, m.atomValue = d, m.selectorValue = m.selector(m.atomValue));
    }
    return n(function () {
      return "outOfDate" === m.mountStatus && (m.mountStatus = "upToDate", c()), m.mountStatus = "upToDate", function () {
        return m.unsubscribe();
      };
    }, []), m.selectorValue;
  };
}

var m = f();

function d(t) {
  return void 0 === t && (t = s), function (e, r) {
    void 0 === r && (r = []);
    var n = o(t);
    if (!n) throw new Error("[reatom] The provider is not defined");
    if ("function" != typeof e) throw new TypeError("[reatom] `useAction` argument must be a function");
    return u(function () {
      var t = e.apply(void 0, [].slice.call(arguments));

      if (t) {
        var o = Object.assign({}, n, {
          dispatch: function dispatch(t) {
            var e = Object.assign({}, t, {
              reactions: (t.reactions || []).map(function (t) {
                return function (e) {
                  return t(e, o);
                };
              })
            });
            a.unstable_batchedUpdates(function () {
              return n.dispatch(e);
            });
          }
        });
        o.dispatch(t);
      }
    }, r.concat(n));
  };
}

var v = d();
export { c as Provider, s as context, d as createActionHook, f as createAtomHook, v as useAction, m as useAtom };